var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "accordion-content__client" },
    [
      _vm.get(_vm.paymentInfo, "pingpong_accounts.length")
        ? _c("settings-payment-pingpong-accounts", {
            attrs: { selectable: _vm.selectable }
          })
        : _c(
            "vs-layout",
            {
              staticClass: "pingpong",
              attrs: {
                "wrap-xs": "wrap-xs",
                "vert-align-center-xs": "vert-align-center-xs"
              }
            },
            [
              _c(
                "vs-layout",
                {
                  attrs: {
                    "horz-align-center-xs": "horz-align-center-xs",
                    "margin-top": "2"
                  }
                },
                [
                  _c("vs-button", {
                    staticClass: "pingpong--smaller-text",
                    attrs: {
                      large: "large",
                      text: "Connect PingPong Account",
                      processing: _vm.processing,
                      disabled: _vm.processing,
                      "single-line-button": "single-line-button"
                    },
                    on: { click: _vm.register }
                  })
                ],
                1
              ),
              _c("vs-layout", { attrs: { "margin-top": "2" } }, [
                _c("hr", { staticClass: "pingpong__hr" })
              ]),
              _c(
                "vs-layout",
                {
                  attrs: {
                    "horz-align-center-xs": "horz-align-center-xs",
                    sm: "4",
                    lg: "3",
                    "margin-top": "2"
                  }
                },
                [
                  _c("div", {
                    staticClass: "pingpong__img",
                    style: _vm.pingpongImage
                  })
                ]
              ),
              _c(
                "vs-layout",
                {
                  attrs: {
                    "col-xs": "col-xs",
                    "vert-align-top-xs": "vert-align-top-xs",
                    sm: "8",
                    lg: "9",
                    "margin-top": "2"
                  }
                },
                [
                  _c("h6", { staticClass: "pingpong__text" }, [
                    _vm._v(
                      "More than 43,000 e-commerce merchants around the world trust PingPong to save them money on cross-border payments, VAT payments, supplier payments, and more. To date, PingPong has processed more than $10 billion for global e-commerce sellers."
                    )
                  ]),
                  _c("h6", { staticClass: "pingpong__register" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://pipopmt.com/Viralstyle",
                          target: "_blank"
                        }
                      },
                      [_vm._v("Register here for a PingPong Account!")]
                    )
                  ])
                ]
              )
            ],
            1
          ),
      !_vm.modal && _vm.get(_vm.paymentInfo, "pingpong_accounts.length")
        ? _c("vs-button", {
            attrs: {
              large: "large",
              text: "Connect Another PingPong Account",
              processing: _vm.processing,
              disabled: _vm.processing
            },
            on: { click: _vm.register }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }